<template>
<div>
    <Breadcrumbs main="Admin" submain="Content" title="Publication" />
    <!-- Container-fluid starts-->
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="card">

                    <div class="card-header">
                        <div style="display: flex; justify-content: space-between; gap: 8px;">
                            <button class="btn btn-primary" type="submit" v-b-modal.modal-prevent-closing style="display: flex; gap: 12px; align-items: center;">
                                <i class="fa fa-light fa-plus"></i>
                                <h7>Add New</h7>
                            </button>
                            <div v-if="serial_wise_data.length > 0">
                                <button class="btn btn-secondary" type="submit" @click="updateBulkSerial">Update Bulk Serial</button>
                            </div>
                        </div>
                    </div>

                    <div class="card-body">
                        <b-row class="d-flex justify-content-center align-items-center">
                            <b-col xl="6" class="d-flex flex-wrap" style="gap: 20px">
                                <b-input-group style="width: 340px;">
                                    <b-form-input v-model="filter" placeholder="Type to Search" style="box-shadow: none;"></b-form-input>
                                    <b-input-group-append>
                                        <b-button @click="filter = ''">Clear</b-button>
                                    </b-input-group-append>
                                </b-input-group>
                            </b-col>

                            <b-col xl="6">
                                <b-form-group label-cols="3" label="Per page" class="mb-0 datatable-select w-100">
                                    <b-form-select v-model="perPage" :options="pageOptions" style="width: 100%;"></b-form-select>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <div v-if="!loading && !error">
                            <div class="table-responsive datatable-vue" style="margin-top: 22px;">
                                <b-table show-empty stacked="md" :items="publication_list" :fields="tablefields" :current-page="currentPage" :per-page="perPage">
                                    <template #cell(index)="data">
                                        {{ (currentPage - 1) * perPage + data.index + 1 }}
                                    </template>

                                    <template #cell(image)="row">
                                        <img :src="host + row.item.image" alt="" style="max-width: 120px;">
                                    </template>

                                    <template #cell(title)="row">
                                        <div v-if="row.item.title" style="max-width: 250px; margin-right: 12px;">
                                            <div>{{ row.item?.title }}</div>
                                            <div style="display: flex; margin-top: 4px;" v-if="row.item?.pub_link">
                                                <p class="mr-1">Link: </p>
                                                <a :href="row.item?.pub_link" target="_blank" rel="noopener noreferrer" style="color: blue; word-break: break-all; white-space: normal; max-width: 180px; display: inline-block;">
                                                    {{ row.item?.pub_link }}
                                                </a>
                                            </div>
                                        </div>
                                    </template>

                                    <template #cell(category)="row">
                                        <div v-if="row.item.category" style="max-width: 200px;">
                                            <div>{{ row.item.category?.title }}</div>
                                        </div>
                                    </template>

                                    <template #cell(details)="row">
                                        <div v-if="row.item.details && row.item.details.length > 200" style="max-width: 500px;">
                                            <div v-html="row.item.details.slice(0, 200) + '...'"></div>
                                        </div>
                                        <div v-else style="max-width: 500px;">
                                            <div v-html="row.item.details"></div>
                                        </div>
                                    </template>

                                    <template #cell(featured)="row">
                                        <div>
                                            <span v-if="row.item.featured === true" style="cursor: pointer;">
                                                <b-badge pill variant="success" v-b-tooltip.hover title="Toggle featured" @click="toggleFeatured(row.item.slug)">Yes</b-badge>
                                            </span>
                                            <span v-if="row.item.featured === false" style="cursor: pointer;">
                                                <b-badge pill variant="danger" v-b-tooltip.hover title="Toggle featured" @click="toggleFeatured(row.item.slug)">No</b-badge>
                                            </span>
                                        </div>
                                    </template>

                                    <template #cell(serial)="row">
                                        <div style="max-width: 60px;">
                                            <input @keyup.enter="updateSerial(row.item)" @keyup="getSerial(row.item)" type="text" class="form-control" v-model="row.item.serial" placeholder="Enter Serial" />
                                        </div>
                                    </template>

                                    <template #cell(action)="data">
                                        <span style="display: flex; gap: 12px;">
                                            <div>
                                                <feather type="delete" size="22px" style="color: #ff595d; cursor: pointer;" v-b-tooltip.hover v-b-modal.modal-center @click="deletePublication(data.item.id)" title="Delete"></feather>
                                            </div>
                                            <div @click="editPublication(data.item)">
                                                <feather type="edit" size="20px" style="color: #568ae3; cursor: pointer;" v-b-tooltip.hover title="Edit" v-b-modal.modal-prevent-closing-edit></feather>
                                            </div>
                                        </span>
                                    </template>
                                </b-table>
                            </div>
                        </div>

                        <div v-else>
                            <loader />
                        </div>

                        <b-col md="6" class="my-1 p-0">
                            <b-pagination v-model="currentPage" :total-rows="totalRows" :per-page="perPage" class="my-0"></b-pagination>
                        </b-col>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <!-- Container-fluid Ends-->

    <!-- BLog Create Modal -->
    <b-modal id="modal-prevent-closing" ref="modal" title="Add Publication" size="xl" @show="resetModal" @hidden="resetModal" @ok="handleOk">
        <form ref="form" @submit.stop.prevent="handleSubmit()">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter publication title" v-model="publication.title">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Publication Link</label>
                        <input class="form-control" type="text" placeholder="Enter publication link" v-model="publication.pub_link">
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Youtube Video Link</label>
                        <input class="form-control" type="text" placeholder="Enter publication video link" v-model="publication.link">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="publication.category">
                            <option v-for="(type, index) in categories" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <ckeditor :editor="editor" placeholder="Enter publication details" v-model="publication.details"></ckeditor>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Upload PDF</label>
                        <b-form-file v-model="publication.pdf" placeholder="Choose a pdf or drop it here..." drop-placeholder="Drop pdf here..." @change="uploadPDF"></b-form-file>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Image</label>
                        <div class="flex items-center">
                            <img v-if="show_image" style="max-width: 120px;" :src="show_image">
                            <input :class="show_image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="uploadFile">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Publication Edit Modal -->
    <b-modal id="modal-prevent-closing-edit" ref="modal" title="Edit Publication" size="xl" @show="resetEditModal" @hidden="resetEditModal" @ok="handleEditOk">
        <form ref="form" @submit.stop.prevent="handleEditSubmit">
            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Title</label>
                        <input class="form-control" type="text" placeholder="Enter publication title" v-model="edit_publication.title">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Publication Link</label>
                        <input class="form-control" type="text" placeholder="Enter publication link" v-model="edit_publication.pub_link">
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Youtube Video Link</label>
                        <input class="form-control" type="text" placeholder="Enter publication video link" v-model="edit_publication.link">
                    </div>
                </div>
                <div class="col-sm-6">
                    <div class="form-group">
                        <label>Category</label>
                        <select class="form-control digits" v-model="edit_publication.category">
                            <option v-for="(type, index) in categories" :key="index" :value="type.id">{{ type.title }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Description</label>
                        <ckeditor :editor="editor" placeholder="Enter publication details" v-model="edit_publication.details"></ckeditor>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col">
                    <div class="form-group">
                        <label>Upload PDF</label>
                        <div class="mb-1">Current: <a :href="show_pdf" target="_blank" rel="noopener noreferrer">{{ show_pdf }}</a></div>
                        <b-form-file v-model="edit_publication.pdf" placeholder="Choose a pdf or drop it here..." drop-placeholder="Drop pdf here..." @change="edit_uploadPDF"></b-form-file>
                    </div>
                </div>
            </div>

            <div class="row">
                <div class="col-sm-12">
                    <div class="form-group">
                        <label>Image</label>
                        <div class="flex items-center">
                            <img v-if="show_image" style="max-width: 120px;" :src="show_image">
                            <input :class="show_image ? 'ml-2' : 'ml-0'" type="file" accept="image/*" @change="editUploadFile">
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </b-modal>

    <!-- Gallery Delete Modal -->
    <b-modal id="modal-center" centered hide-header @ok="handleDeleteOk">
        <div class="mt-4 mb-4" style="font-size: large;">Are you sure you want to delete this publication?</div>
    </b-modal>
</div>
</template>

<script>
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Datepicker from 'vuejs-datepicker';
import Swal from 'sweetalert2/dist/sweetalert2.js';
import 'sweetalert2/src/sweetalert2.scss';
import {
    mapState
} from 'vuex';
import {
    myHost
} from '../../../../_helpers/host';
import loader from '../../loader/loader.vue';

export default {
    components: {
        Datepicker,
        loader
    },

    data() {
        return {
            editor: ClassicEditor,
            host: myHost.host,
            tablefields: [{
                    key: 'index',
                    label: '#'
                },
                {
                    key: 'title',
                    label: 'Title',
                    sortable: true
                },
                {
                    key: 'category',
                    label: 'Category',
                    sortable: true
                },
                {
                    key: 'details',
                    label: 'Description',
                    sortable: true
                },
                {
                    key: 'image',
                    label: 'Image',
                    sortable: true
                },
                {
                    key: 'featured',
                    label: 'Featured',
                    sortable: true
                },
                {
                    key: 'serial',
                    label: 'Serial',
                    sortable: true
                },
                {
                    key: 'action',
                    label: 'Action',
                    sortable: false
                }
            ],

            publication: {
                title: '',
                image: null,
                pdf: null,
                details: '',
                link: '',
                pub_link: '',
                category: ''
            },

            edit_publication: {
                id: '',
                title: '',
                image: null,
                pdf: null,
                details: '',
                link: '',
                pub_link: '',
                category: ''
            },

            show_image: null,
            show_pdf: null,

            delete_value: null,
            filter: null,
            totalRows: 1,
            currentPage: 1,
            perPage: 10,
            pageOptions: [5, 10, 15],
            serial_wise_data: []
        };
    },

    computed: {
        ...mapState({
            publication_list: state => state.publication.publication,
            categories: state => state.publication.category,
            loading: state => state.publication.publicationLoading,
            error: state => state.publication.publicationError
        }),

        sortOptions() {
            return this.tablefields
                .filter(f => f.sortable)
                .map(f => {
                    return {
                        text: f.label,
                        value: f.key
                    };
                });
        }
    },

    mounted() {
        this.$store.dispatch("publication/fetchCategory")
        this.$store.dispatch("publication/fetchPublication").then(() => {
            this.items = this.publication_list
            this.totalRows = this.publication_list.length;
        });
    },

    methods: {
        updateSerial(pub) {
            this.$store.dispatch("publication/updateSerial", pub).then(response => {
                if (response.data.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.$store.dispatch("publication/fetchPublication").then(() => {
                        this.items = this.publication_list
                        this.totalRows = this.publication_list.length;
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        getSerial(data) {
            // remove the entry if user clears the serial
            if (!data.serial || data.serial.trim() === "") {
                this.serial_wise_data = this.serial_wise_data.filter(
                    item => item.id !== data.id
                );
                return;
            }

            // check if already exists
            const existing = this.serial_wise_data.find(item => item.id === data.id);

            if (existing) {
                // update serial
                existing.serial = data.serial;
            } else {
                // add new entry
                this.serial_wise_data.push({
                    id: data.id,
                    serial: data.serial
                });
            }
        },

        updateBulkSerial() {
            this.serial_wise_data.forEach(project => {
                this.$store.dispatch("publication/updateSerial", project).then(response => {
                    if (response.data.code == 200) {
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                        this.$store.dispatch("publication/fetchPublication").then(() => {
                            this.items = this.publication_list
                            this.totalRows = this.publication_list.length;
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                });
            });

            this.serial_wise_data = [];
        },

        uploadPDF(e) {
            this.publication.pdf = e.target.files[0];
        },

        edit_uploadPDF(e) {
            this.edit_publication.pdf = e.target.files[0];
        },

        uploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image = e.target.result
                this.publication.image = e.target.result;
            };
        },

        editUploadFile(e) {
            const image = e.target.files[0];
            const reader = new FileReader();
            reader.readAsDataURL(image);
            reader.onload = e => {
                this.show_image = e.target.result
                this.edit_publication.image = e.target.result;
            };
        },

        onFiltered(filteredItems) {
            this.totalRows = filteredItems.length;
            this.currentPage = 1;
        },

        resetModal() {
            this.publication.title = null
            this.publication.details = null
            this.publication.category = null
            this.show_image = null
            this.publication.link = null
            this.publication.pub_link = null
            this.publication.pdf = null
        },

        handleOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleSubmit()
        },

        handleSubmit() {
            this.$store.dispatch("publication/addPublication", {
                publication: this.publication
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetModal()
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing')
            })
        },

        editPublication(detail) {
            this.edit_publication.id = detail.id ? detail.id : null
            this.edit_publication.title = detail.title ? detail.title : null
            this.edit_publication.details = detail.details ? detail.details : null
            this.edit_publication.link = detail.link ? detail.link : null
            this.edit_publication.pub_link = detail.pub_link ? detail.pub_link : null
            this.edit_publication.category = detail.category ? detail.category.id : null
            this.show_image = detail.image ? this.host + detail.image : null
            this.show_pdf = detail.pdf ? this.host + detail.pdf : null
        },

        resetEditModal() {
            this.edit_publication.id = null
            this.edit_publication.title = null
            this.edit_publication.details = null
            this.edit_publication.category = null
            this.edit_publication.link = null
            this.edit_publication.pub_link = null
            this.edit_publication.pdf = null
            this.show_image = null
        },

        handleEditOk(bvModalEvent) {
            bvModalEvent.preventDefault()
            this.handleEditSubmit()
        },

        handleEditSubmit() {
            this.$store.dispatch("publication/updatePublication", {
                id: this.edit_publication.id,
                publication: this.edit_publication
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.resetEditModal()
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })

            this.$nextTick(() => {
                this.$bvModal.hide('modal-prevent-closing-edit')
            })
        },

        toggleFeatured(type) {
            this.$store.dispatch("publication/toggleFeatured", {
                id: type
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        },

        deletePublication(id) {
            this.delete_value = id
        },

        handleDeleteOk() {
            this.$store.dispatch("publication/deletePublication", {
                delete: this.delete_value
            }).then(response => {
                if (response.code == 200) {
                    Swal.fire({
                        title: "Success!",
                        text: response.response,
                        icon: "success"
                    });
                    this.delete_value = null
                } else {
                    Swal.fire({
                        title: "Error!",
                        text: response.response,
                        icon: "error"
                    });
                }
            })
        }
    }
};
</script>
